export class ConfigHelper {
  public static STONEITY_APP_ENV_NAME: string = 'STONEITY_APP_ENV_NAME';
  public static STONEITY_APP_LANG: string = 'STONEITY_APP_LANG';
  public static STONEITY_USER_TOKEN: string = 'STONEITY_USER_TOKEN';
  public static STONEITY_USER_REFRESH_TOKEN: string = 'STONEITY_USER_REFRESH_TOKEN';
  public static STONEITY_USER_TOKEN_CREATE_TIME: string = 'STONEITY_USER_TOKEN_CREATE_TIME';
  public static STONEITY_USER_DATA: string = 'STONEITY_USER_DATA';
  public static STONEITY_SELECTED_THEME: string = 'STONEITY_SELECTED_THEME';
  public static STONEITY_ROLE_ID: string = 'STONEITY_ROLE_ID';
  public static STONEITY_IS_GET_TO_KNOW: string = 'STONEITY_IS_GET_TO_KNOW';
}

export class Pattern {
  public static NUMERIC: string = '[0-9]*';
  public static ALPHABETIC: string = '[a-zA-ZğüşöçİĞÜŞÖÇ]+';
  public static ALPHABETIC_WITH_SPACES: string = '[a-zA-ZğüşöçİĞÜŞÖÇ ]+';
  public static ALPHABETIC_LOWERCASE: string = '[a-zğüşöçİĞÜŞÖÇ]+';
  public static ALPHABETIC_LOWERCASE_WITH_SPACES: string = '[a-zğüşöçİĞÜŞÖÇ ]+';
  public static ALPHABETIC_UPPERCASE: string = '[A-ZğüşöçİĞÜŞÖÇ]+';
  public static ALPHABETIC_UPPERCASE_WITH_SPACES: string = '[A-ZğüşöçİĞÜŞÖÇ ]+';
  public static ALPHANUMERIC: string = '[a-zA-Z0-9ğüşöçİĞÜŞÖÇ]+';
  public static ALPHANUMERIC_WITH_SPACES: string = '[a-zA-Z0-9ğüşöçİĞÜŞÖÇ ]+';
  public static ALPHANUMERIC_LOWERCASE: string = '[a-z0-9ğüşöçİĞÜŞÖÇ]+';
  public static ALPHANUMERIC_LOWERCASE_WITH_SPACES: string = '[a-z0-9ğüşöçİĞÜŞÖÇ ]+';
  public static ALPHANUMERIC_UPPERCASE: string = '[A-Z0-9ğüşöçİĞÜŞÖÇ]+';
  public static ALPHANUMERIC_UPPERCASE_WITH_SPACES: string = '[A-Z0-9ğüşöçİĞÜŞÖÇ ]+';
  public static EMAIL: string = '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$';
  public static PRICE: string = '[0-9]+(\\.[0-9][0-9]?)?';
}

export class COOKIE_POLICY {
  public static ACCEPTED_COOKIE_POLICY: string = 'AcceptedCookiePolicy';
  public static MAIL_CONFIRMATION_CODE_SEND_DATE: string = 'MailConfirmationCodeSendDate';
  public static MAIL_CONFIRMATION_CODE_MAIL_ADDRESS: string = 'MailConfirmationCodeMailAddress';
}